import script from "./Sub2.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sub2.vue?vue&type=script&setup=true&lang=ts"

import "./Sub2.vue?vue&type=style&index=0&id=9075a89e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9075a89e"]])

export default __exports__